import { useApolloClient } from '@apollo/client/react';

import type { EmbeddedBrowserSessionPort } from '@/shared-responder-v2-core';
import { useEmbedSessionPort } from '@/shared-responder-v2-media';
import { createHyperbeamSessionGateway } from '@/shared-survey';

import { createSurveyEmbedProbe } from './shared-responder-v2-gateway-embed-probe';

// test-exception: Apollo binding + the fixed useEmbedSessionPort hook only — the probe is covered by shared-responder-v2-gateway-embed-probe.spec.ts and the gateway by shared-survey-hyperbeam-session.gateway.spec.ts.
export function useSurveyEmbedSessionPort(
  baseUrl: string
): EmbeddedBrowserSessionPort {
  const client = useApolloClient();

  return useEmbedSessionPort({
    probe: createSurveyEmbedProbe(baseUrl),
    remote: createHyperbeamSessionGateway(client),
  });
}
